import { useState, useEffect } from "react";
import { FaPowerOff } from "react-icons/fa";
import { API_BASE } from "../config";
export default function PowerOverview() {
  const [switches, setSwitches] = useState([]);
  const [loading, setLoading] = useState(true);

  const formatTime = (time) => {
    if (!time) return "-";
    const date = new Date(time);
    return date.toLocaleString("id-ID", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
    });
  };

  useEffect(() => {
    fetch(`${API_BASE}/api/power/overview`)
      .then((res) => res.json())
      .then((data) => {
        setSwitches(Array.isArray(data) ? data : []);
        setLoading(false);
      })
      .catch((err) => {
        console.error("❌ Gagal ambil overview:", err);
        setLoading(false);
      });
  }, []);

  if (loading) {
    return <p className="p-6 text-center text-gray-500">Loading overview...</p>;
  }

  return (
    <div className="p-6">
      <h2 className="text-2xl font-bold mb-6 text-center text-gray-800">Overview</h2>
      <div className="grid sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {switches.map((sw) => (
          <div
            key={sw.id}
            className="relative bg-white rounded-xl shadow-lg p-6 hover:shadow-xl transition-all border border-gray-100"
          >
            {/* Status Badge */}
            <div className="absolute top-4 right-4 flex items-center gap-1">
              <FaPowerOff
                className={`w-5 h-5 ${
                  sw.status === "ON" ? "text-green-500" : "text-red-500"
                }`}
              />
              <span
                className={`px-2 py-1 rounded-full text-xs font-semibold ${
                  sw.status === "ON" ? "bg-green-100 text-green-800" : "bg-red-100 text-red-800"
                }`}
              >
                {sw.status}
              </span>
            </div>

            {/* Device Info */}
            <h3 className="text-lg font-bold text-gray-900 mb-1">{sw.name}</h3>
            <p className="text-sm text-gray-500 mb-2">{sw.location}</p>
            <p className="text-sm text-gray-600">
              Last Used: <span className="font-medium">{sw.lastUser}</span>
            </p>
            <p className="text-sm text-gray-500">{formatTime(sw.lastTime)}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
